/* Hero Maison Sirito : bascule entre les diapositives et pilote les indicateurs. */

class SiritoHero extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.sirito-hero__slide'));
    this.indicators = Array.from(this.querySelectorAll('.sirito-hero__indicator'));
    if (this.slides.length < 2) return;

    this.index = 0;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.indicators.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.goTo(Number(btn.dataset.index));
        this.restart();
      });
    });

    // Le survol suspend le défilement pour laisser le temps de lire et de cliquer.
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    /* Glissement au doigt.

       Sur un téléphone, les indicateurs font 190px de large mais 2px de haut :
       impossible à viser. Sans glissement, le carrousel n'y était pilotable
       que par l'attente. On suit donc le doigt et on bascule au-delà d'un
       seuil, en laissant passer les gestes verticaux — sans quoi on
       empêcherait de faire défiler la page. */
    const SEUIL = 45;
    let departX = null;
    let departY = null;

    this.addEventListener(
      'touchstart',
      (event) => {
        if (event.touches.length !== 1) return;
        departX = event.touches[0].clientX;
        departY = event.touches[0].clientY;
        this.stop();
      },
      { passive: true }
    );

    this.addEventListener(
      'touchend',
      (event) => {
        if (departX === null) return;
        const arrivee = event.changedTouches[0];
        const dx = arrivee.clientX - departX;
        const dy = arrivee.clientY - departY;
        departX = null;
        departY = null;
        // Un geste plus vertical qu'horizontal appartient au défilement.
        if (Math.abs(dx) < SEUIL || Math.abs(dx) < Math.abs(dy)) {
          this.start();
          return;
        }
        this.goTo(this.index + (dx < 0 ? 1 : -1));
        this.restart();
      },
      { passive: true }
    );

    /* Flèches du clavier, quand la main est dans le carrousel. */
    this.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      this.restart();
    });

    this.start();

    // Dans le personnalisateur, sélectionner une diapositive doit l'afficher.
    document.addEventListener('shopify:block:select', (event) => {
      if (!this.contains(event.target)) return;
      const slide = event.target.closest('.sirito-hero__slide');
      if (!slide) return;
      this.stop();
      this.goTo(Number(slide.dataset.index));
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      if (this.contains(event.target)) this.start();
    });
  }

  disconnectedCallback() {
    this.stop();
  }

  start() {
    if (this.dataset.autoplay !== 'true' || this.reduceMotion) return;
    this.stop();
    const speed = (parseFloat(this.dataset.speed) || 6) * 1000;
    this.timer = setInterval(() => this.goTo(this.index + 1), speed);
  }

  stop() {
    clearInterval(this.timer);
  }

  restart() {
    this.stop();
    this.start();
  }

  goTo(next) {
    const target = ((next % this.slides.length) + this.slides.length) % this.slides.length;
    if (target === this.index) return;

    this.slides[this.index].classList.remove('sirito-hero__slide--active');
    this.slides[this.index].setAttribute('aria-hidden', 'true');
    this.slides[target].classList.add('sirito-hero__slide--active');
    this.slides[target].removeAttribute('aria-hidden');

    if (this.indicators.length) {
      this.indicators[this.index].classList.remove('sirito-hero__indicator--active');
      this.indicators[this.index].setAttribute('aria-current', 'false');
      this.indicators[target].classList.add('sirito-hero__indicator--active');
      this.indicators[target].setAttribute('aria-current', 'true');
    }

    this.index = target;
  }
}

customElements.define('sirito-hero', SiritoHero);
